export default {
  title: "程式碼",
  blocks: "積木",
  linkTooltip: "儲存積木組並提供連結。",
  runTooltip: "於工作區中執行積木組所定義的程式。",
  badCode: "程式錯誤：\n%1",
  timeout: "超過最大執行數。",
  trashTooltip: "捨棄所有積木。",
  catEvent: "事件",
  catLogic: "邏輯",
  catLoops: "迴圈",
  catMath: "數學式",
  catText: "文字",
  catLists: "列表",
  catColour: "顏色",
  catVariables: "變量",
  catFunctions: "流程",
  listVariable: "列表",
  textVariable: "文字",
  httpRequestError: "命令出現錯誤。",
  linkAlert: "透過此連結分享您的積木組：\n\n%1",
  hashError: "對不起，「%1」並未對應任何已保存的程式。",
  xmlError: "未能載入您保存的檔案。或許它是由其他版本的Blockly創建？",
  badXml:
    "解析 XML 時出現錯誤：\n%1\n\n選擇'確定'以放棄您的更改，或選擇'取消'以進一步編輯 XML。"
};
